/* mediquip custom site js 1.1.0 04/15/2026 */

!(function(){

   	"use strict";

    function libIsArray (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    }

    function libIsObject (obj) {
        return typeof obj === 'object' && obj !== null;
    }

    function libNodesToArray (nodesList) {
        return	nodesList
                ? Array.prototype.slice.call(nodesList)
                : null;
    }

    function libElemAsArray (elem) {
        if (elem) {
            if (libIsArray(elem)) {
                return elem;
            } else if (typeof elem === TYPE_STRING) {
                return libSelectAll(elem);
            } else {
                return [elem];
            }
        } else {
            return undefined;
        }
    }

    // RET: element | null | undefined
    function libSelect (sel, parentElem) {
        if (sel) {
            if (typeof sel === TYPE_STRING) {
                parentElem = parentElem || document;
                return parentElem.querySelector(sel);
            } else if (libIsObject(sel)) {
                return sel;
            } else {
                return null;
            }
        } else {
            return undefined;
        }
    }

    // RET: array of elements OR null
    function libSelectAll (sel, parent, pos) {
        if (sel) {
            var i, elems, nodes;
            // no parent, use document
            if (!parent) {
                elems = libNodesToArray(document.querySelectorAll(sel));
            // parent is array
            } else if (libIsArray(parent)) {
                elems = [];
                for (i=0;i<parent.length;i++) {
                    nodes = parent[i].querySelectorAll(sel);
                    if (nodes) {
                        elems = elems.concat(libNodesToArray(nodes));
                    }
                }
            // else parent is element
            } else {
                elems = libNodesToArray(parent.querySelectorAll(sel));
            }
            if (elems && elems.length) {
                if (pos === 'first') {
                    return elems[0];
                } else if (pos === 'last') {
                    return elems[elems.length - 1];
                } else {
                    return elems;
                }
            } else {
                return null;
            }
        } else {
            return undefined;
        }
    }

    /*function libAddClass (elem, cName) {
        elem = libElemAsArray(elem);
        if (elem && cName) {
            cName = cName.split(' ');
            for (var i=0;i<elem.length;i++) {
                for (var j=0;j<cName.length;j++) {
                    elem[i].classList.add(cName[j]);
                }
            }
        }
    }

    function libRemoveClass (elem, cName) {
        elem = libElemAsArray(elem);
        if (elem && cName) {
            cName = cName.split(' ');
            for (var i=0;i<elem.length;i++) {
                for (var j=0;j<cName.length;j++) {
                    elem[i].classList.remove(cName[j]);
                }
            }
        }
    }

    function libHasClass (elem, cName) {
        elem = libSelect(elem);
        return  elem
                ? elem.classList.contains(cName)
                : false;
    }*/

    function libHTML (elem, html) {
        elem = libSelect(elem);
        if (elem) {
            // GET
            if (typeof html === TYPE_UNDEFINED) {
                return elem.innerHTML;
            // SET
            } else {
                elem.innerHTML = html;
            }
        } else {
            return undefined;
        }
    }

    function libTrigger (elem, eventName) {
        elem = libSelect(elem);
        if (elem && eventName) {
            if (eventName === 'click') {
                elem.click();
            } else if (eventName === 'blur') {
                elem.blur();
            } else if (eventName === 'focus') {
                elem.focus();
            } else {
                var triggerEvent = new Event(eventName);
                elem.dispatchEvent(triggerEvent);
            }
        }
    }

    // ----------------------------------------------------------------------
    function log (msg) {
        window.console && window.console.log && window.console.log(msg);
    }

    /*// ----------------------------------------------------------------------
	function isPage (keyword, mode) {
		let
		i,
		keywords,
		ok = false;
		if (!keyword) {
			return false; //--->
		}
		if (mode === true) {
			libAddClass(eBody, keyword);
		} else if (mode === false) {
			libRemoveClass(eBody, keyword);
		} else {
			keywords = keyword.split(' ');
			for (i=0;i<keywords.length;i++) {
                switch (keywords[i]) {
                    case 'store-editor':
                        ok = libHasClass(eBody, 'store-editor');
                        break;
                    case 'product':
                        ok = !!libSelect(settings.productPageSel);
                        break;
                }
				if (ok) {
					break; //--->
				}
			}
			return !!ok;
		}
	}*/

    // ----------------------------------------------------------------------
    function productTotalsSetup () {

        let
        timer,
        timerAcc    = 0,
        timerInt    = 250,
        timerMax    = 5000;

        /*if (!isPage('product')) {
            return; //--->
        }*/

        timer =     window.setInterval(
                        function(){

                            let
                            html,
                            done        = false,
                            found       = false,
                            eTotals     = libSelect(settings.productPageTotalsSel);

                            if (timerAcc >= timerMax) {
                                done = true;
                            }

                            if (eTotals) {
                                done    = true;
                                found   = true;
                            }

                            if (done) {

                                window.clearInterval(timer);

                                if (found) {

                                    log('found totals');
                                    html = libHTML(eTotals);
                                    html =  html
                                                .replace('Total unit:', 'Total Units:')
                                                .replace('Total price:', 'Total Price:');
                                    libHTML(eTotals, html);
                                    
                                }

                                return; //--->

                            }

                            timerAcc += timerInt;

                        },
                        timerInt
                    );

    }

    // ----------------------------------------------------------------------
    function productImagesSetup () {

        let
        timer,
        timerAcc    = 0,
        timerInt    = 250,
        timerMax    = 5000;

        /*if (!isPage('product')) {
            return; //--->
        }*/

        timer =     window.setInterval(
                        function(){

                            let
                            i,
                            eImgs,
                            done    = false,
                            found   = false;

                            eImgs = libSelectAll('.multivariants_block_img_holder .mkmid_m img');

                            if (timerAcc >= timerMax) {
                                done = true;
                            }

                            if (eImgs) {
                                done    = true;
                                found   = true;
                            }

                            if (done) {

                                window.clearInterval(timer);

                                if (found) {
                                    for (i=0;i<eImgs.length;i++) {
                                        eImgs[i]
                                            .setAttribute('onclick', '');
                                        eImgs[i]
                                            .addEventListener(
                                                'click',
                                                function(e){
                                                    let
                                                    i,
                                                    key,
                                                    pos1,
                                                    pos2,
                                                    eButtons,
                                                    img,
                                                    imgUrl,
                                                    url = e.target.getAttribute('src');

                                                    e.preventDefault();

                                                    do { // control

                                                        pos1 = url.lastIndexOf('/');
                                                        if (pos1 === -1) {
                                                            break; //--->
                                                        }

                                                        pos2 = url.indexOf('_', pos1 + 1);
                                                        if (pos2 === -1) {
                                                            break; //--->
                                                        }

                                                        key = url.substring(pos1 + 1, pos2);

                                                        eButtons = libSelectAll('.slideshow-controls__thumbnails button');

                                                        if (!eButtons) {
                                                            break; //--->
                                                        }

                                                        for (i=0;i<eButtons.length;i++) {

                                                            img = libSelect('img', eButtons[i]);
                                                            if (!img) {
                                                                continue; //--->
                                                            }

                                                            imgUrl = img.getAttribute('src');
                                                            if (imgUrl.indexOf(key) !== -1) {
                                                                libTrigger(eButtons[i], 'click');
                                                                break; //---> done
                                                            }

                                                        }

                                                    } while(0); // control

                                                    return false;

                                                }
                                            );
                                    }
                                }

                                return; //--->

                            }

                            timerAcc += timerInt;

                        },
                        timerInt
                    );

    }

    // ----------------------------------------------------------------------
    function setup () {

        eBody = libSelect('body');

        settings = {

            productPageSel          : 'div[data-testid="product-information"]',
            productPageTotalsSel    : '#multivariants_block_subtotal_h .multivariants_block_subtotal_label'

        };

    }

    // ----------------------------------------------------------------------

    const

    TYPE_UNDEFINED  = 'undefined',
    TYPE_STRING     = 'string';

    let

    settings,
    eBody;

    // ----------------------------------------------------------------------

    setup();
    productTotalsSetup();
    productImagesSetup();

})();